<template lang="pug">
  div.event-response
    //- .top
    //-   div 回应方
    //-   div 内容
    //-   div 回应时间
    //-   div 原文链接
    //-   div 回应类型
    div.list(v-for="(l, i) in lists" :key="i")
      div.channel
        p {{l.brand}}
      div.content
        p {{l.content}}
          i.fa.fa-picture-o(v-if="l.img" @click.prevent="viewImg(l)")
      div.time 回应时间：{{l.publishTime}}（{{l.hours}}）
      div.url
        a(:href="l.url" target="_blank" v-if="l.url") 原文链接
      div.url {{ l.replyType || '--' }}
    img-viewer(v-if="showImg" @close="showImg = false" :img="img")
</template>

<script>
import client from '../server/server'
import moment from 'moment'
import ImgViewer from '../components/ImgViewer'
import { parseUrl } from '../config/config'
export default {
  name: 'EventResponse',
  data () {
    return {
      lists: [],
      showImg: false,
      img: ''
    }
  },
  components: {
    ImgViewer
  },
  mounted () {
    this.getIntervene()
  },
  methods: {
    getIntervene () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventIntervene(params)
        .then(res => {
          if (res.success) {
            this.lists = res.data.map(d => {
              return Object.assign({}, d, {
                hours: d.hours > 48 ? '大于48小时' : `${d.hours}小时`,
                publishTime: moment(d.publishTime).format('YYYY-MM-DD HH时'),
                url: d.url ? parseUrl(d.url) : d.url,
                img: d.img ? this.$imgParse(d.img) : d.img
              })
            })
          }
        })
    },
    viewImg (n) {
      this.showImg = true
      this.img = n.img
    }
  }
}
</script>

<style lang="scss" scoped>
.event-response {
  height: 760px;
  background-color: #fff;
  border-radius: 4px;
  padding: 0 24px;

  .list {
    padding: 30px 0;
    border-bottom: 1px solid #f0f0f0;
    display: flex;

    .channel {
      flex: 8;
      text-align: center;
      color: #333;

      .platform {
        color: #666;
        font-size: 12px;
        margin-top: 6px;
      }
    }

    .content {
      flex: 45;
      color: #666;
      display: flex;
      align-items: center;

      i {
        margin-left: 5px;
        color: #999;

        &:hover {
          color: #3989cb;
        }
      }
    }

    .time {
      flex: 11;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }

    .url {
      flex: 5;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;

      a {
        color: #3989cb;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventResponse/EventResponse.vue